import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { RetailerOpeningHours } from '../../@types/Retailer';
import { getRetailerOpeningHours } from '../../selectors/retailer';

const BranchOpeningHours = () => {
  const { t } = useTranslation(['glossary', 'item']);
  const openingHours = useSelector(getRetailerOpeningHours);

  const [isOpen, setIsOpen] = useState(false);
  if (!openingHours) return null;

  const dayNames: (keyof RetailerOpeningHours)[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  const translatedDayNames = [
    t('sundayShort', { ns: 'glossary' }),
    t('mondayShort', { ns: 'glossary' }),
    t('tuesdayShort', { ns: 'glossary' }),
    t('wednesdayShort', { ns: 'glossary' }),
    t('thursdayShort', { ns: 'glossary' }),
    t('fridayShort', { ns: 'glossary' }),
    t('saturdayShort', { ns: 'glossary' }),
  ];
  const dateIndex = [1, 2, 3, 4, 5, 6, 0];

  const todayNameKey = dayNames[new Date().getDay()];
  const today = openingHours[todayNameKey];

  const left = [];
  const right = [];

  if (today) {
    let title = t('Closed today', { ns: 'item' });
    let time = '';
    if (today.openFrom && today.openTo) {
      title = t('Open today', { ns: 'item' });
      time = `${today.openFrom} - ${today.openTo}`;
    }
    left.push(
      <div key={todayNameKey} className="detail-list-label is-main">
        {title}
      </div>,
    );
    right.push(
      <div key={todayNameKey} className="detail-list-value is-main">
        <button type="button" className="detail-list-extend-btn" onClick={() => setIsOpen(!isOpen)}>
          {time}
        </button>
      </div>,
    );
  }

  const mappedOpeningHours: { left: string; right: string }[] = [];
  dateIndex.forEach((x) => {
    const _current = openingHours[dayNames[x]];
    const current = {
      left: translatedDayNames[x],
      right:
        _current.openFrom && _current.openTo
          ? `${_current.openFrom} - ${_current.openTo}`
          : t('Closed', { ns: 'item' }),
    };

    const lastStored = mappedOpeningHours[mappedOpeningHours.length - 1];
    if (lastStored && lastStored.right === current.right) {
      const splittedDate = lastStored.left.toString().split(' -')[0];
      mappedOpeningHours[mappedOpeningHours.length - 1] = {
        ...lastStored,
        left: `${splittedDate} - ${translatedDayNames[x]}`,
      };
    } else {
      mappedOpeningHours.push(current);
    }
  });

  mappedOpeningHours.forEach((x) => {
    left.push(
      <div key={x.left} className="detail-list-label is-extendable">
        {x.left}
      </div>,
    );
    right.push(
      <div key={x.left} className="detail-list-value is-extendable">
        {x.right}
      </div>,
    );
  });

  return (
    <li className={`detail-list-item${isOpen ? ' is-open' : ''}`}>
      <div className="detail-list-item-cell">{left}</div>
      <div className="detail-list-item-cell">{right}</div>
    </li>
  );
};

export default BranchOpeningHours;
